import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import { HeroUIProvider } from "@heroui/react"

import { AuthContextProvider } from "./context/AuthContext"
import { SidebarContextProvider } from "./context/SidebarContext"

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
  <React.StrictMode>
    <SidebarContextProvider>
      <HeroUIProvider>
        <AuthContextProvider>
          <App />
        </AuthContextProvider>
      </HeroUIProvider>
    </SidebarContextProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
